import React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';

import { IBuyboxViewPropsExtended } from '../types';
import { IBrandListData, IMfrmAtpMessage } from '../mfrm-buybox.view';
import Cookies from 'universal-cookie';
import getAddressByZipcodeAction, { GetAddressByZipcodeInput } from '../../../data-actions/get-address-from-zipcode.action';
import { getBlockZipCodeMessage } from '../../../Utilities/get-block-message';
import { oneYearFromNow } from '../../../Utilities/one-year-from-now';
import { ProductCompareBuyboxStateSharing } from '../../../actions/product-compare-buybox-state-sharing';
import { IMFIATPInventoryEntity } from '../../../actions/CoreProductDataServiceEntities.g';
import dayjs from 'dayjs';
import {
    _coreProductATPCall,
    _coreProductATPCallForInventoryStatus,
    _coreProductATPCallForInventoryStatusForAllVariants,
    _smallParcelProductATPCallForInventoryStatus
} from '../../../Utilities/mfrm-buybox-utils';

const _setTime = (time: string | undefined) => {
    if (time) {
        const temp = time.split(' ');
        if (temp?.length > 0) {
            let newDatewithTime = dayjs(Date.now()).format('M/D/YYYY');
            newDatewithTime = `${newDatewithTime} ${temp[0]}:00 ${temp[1].toUpperCase()}`;
            return newDatewithTime;
        }
    }
    return '';
};

const _getSoonestDeliveryDate = (coreProductATPData: IMFIATPInventoryEntity[]): string => {
    let deliveryByMessage = '';
    if (!coreProductATPData.length) {
        return deliveryByMessage;
    }
    for (let index = 0; index < coreProductATPData.length; index++) {
        const item = coreProductATPData[index];
        if (item.Available === 'YES' && item.ATPQuantity !== undefined && parseInt(item.ATPQuantity, 10) > 0) {
            const date = new Date();
            const today = dayjs(Date.now()).format('D M YY');
            const deliveryDate = dayjs(item.SlotDate).format('D M YY');
            const currHour = dayjs(Date.now()).format('H');
            if (today === deliveryDate) {
                deliveryByMessage =
                    _setTime(item.StartTime) !== ''
                        ? parseInt(dayjs(_setTime(item.StartTime)).format('H'), 10) < 14 && parseInt(currHour, 10) < 14
                            ? `Delivery by Today ${dayjs(Date.now()).format('MMM D')} `
                            : `Delivery by Tomorrow ${dayjs(date.setDate(date.getDate() + 1)).format('MMM D')} `
                        : '';
                break;
            } else {
                deliveryByMessage = `Delivery by ${dayjs(item.SlotDate).format('MMM D')} `;
                break;
            }
        }
    }
    return deliveryByMessage;
};

// tslint:disable-next-line: max-line-length
const smallParcelATPInventoryStatusCall = async (
    props: IBuyboxViewPropsExtended,
    outOfStockSmallParcelState: boolean,
    SetoutOfStockSmallParcelState: React.Dispatch<boolean>,
    recordId?: number,
    itemId?: string | undefined,
    zipCode?: any,
    prevZipCode?: any
) => {
    const inventoryStatusData = props.state.batchedAtpInventoryStatusData?.ATPInventoryStatusData
        ? props.state.batchedAtpInventoryStatusData?.ATPInventoryStatusData
        : null;
    const selectedObj = inventoryStatusData
        ? inventoryStatusData?.find(item => item.VariantRecordId?.toString() === props.state.currentProduct?.RecordId?.toString())
        : null;
    if (prevZipCode && prevZipCode !== zipCode && zipCode.length === 5) {
        if (recordId && props.data.product.result?.MasterProductId) {
            await _smallParcelProductATPCallForInventoryStatus(props, recordId, itemId, SetoutOfStockSmallParcelState, true)
                .then()
                .catch();
        }
    } else {
        if (selectedObj) {
            const item = selectedObj;
            if (item.Available === 'YES' && item.Quantity !== undefined && parseInt(item.Quantity, 10) > 0) {
                if (outOfStockSmallParcelState !== false) {
                    SetoutOfStockSmallParcelState(false);
                }
            } else {
                if (outOfStockSmallParcelState !== true) {
                    if (
                        !inventoryStatusData?.some(
                            variant => variant.Available && variant.VariantRecordId !== props.state.currentProduct?.RecordId?.toString()
                        )
                    ) {
                        SetoutOfStockSmallParcelState(true);
                    }
                }
            }
        }
    }
};

const _getProductAttribute = (props: IBuyboxViewPropsExtended) => {
    const {
        data: { productSpecificationData },
        getProductType
    } = props;
    // shippingInformation product attribute value
    const shippingInformationSmall = productSpecificationData.result
        ?.find(attr => attr.Name?.trim() === props.context.app.config.smallParcelAttributeKey)
        ?.TextValue?.toLowerCase();

    return getProductType(shippingInformationSmall);
};

// tslint:enable
const _validateZipCode = (
    props: IBuyboxViewPropsExtended,
    zipcode: string,
    setErrorZipCode: React.Dispatch<string>,
    setItemOutOfMarket: React.Dispatch<boolean>,
    setNewZipCode: React.Dispatch<string>,
    setIsValidZipCode: React.Dispatch<boolean>,
    initial: boolean,
    setIsOOMZipCode: React.Dispatch<boolean>,
    isItemOom: boolean
) => {
    setErrorZipCode('');
    const getAddressByZipcodeInput = new GetAddressByZipcodeInput('USA', zipcode);
    getAddressByZipcodeAction(getAddressByZipcodeInput, props.context.actionContext)
        // getAddressFromZipCodeAsync({ callerContext: props.context.actionContext }, 'USA', zipcode)
        .then(addressByZipcode => {
            if (addressByZipcode?.length) {
                setIsValidZipCode(true);
                const productType = _getProductAttribute(props);
                if (productType === 'Small Parcel' || productType === 'Drop Ship' || productType === 'Core') {
                    const stateObj = addressByZipcode[0];
                    const blockedStates = props.context.app.config.blockedStates;
                    let oomZipCode = false;
                    if (blockedStates !== undefined && blockedStates !== null) {
                        for (let bStateIter = 0; bStateIter < blockedStates.length; bStateIter++) {
                            if (blockedStates[bStateIter].stateName === stateObj.StateId) {
                                oomZipCode = true;
                            }
                        }
                    }
                    if (!oomZipCode) {
                        props.context.actionContext.update(new ProductCompareBuyboxStateSharing(zipcode), { zipCode: zipcode });
                    }
                    setIsOOMZipCode(oomZipCode);
                    const getMessageValue = getBlockZipCodeMessage(stateObj.StateId || '', props.context.app.config.blockedStates);
                    if (getMessageValue?.length > 0) {
                        setErrorZipCode(getMessageValue[0].zipcodeMessage?.replace('{zipcode}', zipcode));
                        setItemOutOfMarket(true);
                    } else {
                        !isItemOom && setItemOutOfMarket(false);
                    }
                } else {
                    setItemOutOfMarket(false);
                }
            } else {
                const cookies = new Cookies();
                setItemOutOfMarket(false);
                setIsValidZipCode(false);
                if (!initial) {
                    setErrorZipCode('Please enter a valid zip code. ');
                    cookies.set(`zip_code`, '', { path: '/', expires: oneYearFromNow() });
                } else {
                    cookies.set(`zip_code`, '', { path: '/', expires: oneYearFromNow() });
                }
            }
        })
        .catch(e => {
            console.log(e, 'Error');
        });
};

// tslint:disable-next-line: max-line-length no-any
const _updateZipCode = (
    newZipCode: string,
    setNewZipCode: React.Dispatch<string>,
    props: IBuyboxViewPropsExtended,
    setErrorZipCode: React.Dispatch<string>,
    setItemOutOfMarket: React.Dispatch<boolean>,
    setIsZipCodeChnaged: React.Dispatch<boolean>,
    setIsValidZipCode: React.Dispatch<boolean>,
    setCoreProductATPData: React.Dispatch<any[]>,
    setATPCallMessage: React.Dispatch<any>,
    setIsOOMZipCode: React.Dispatch<boolean>,
    setIsItemOom: React.Dispatch<boolean>,
    isItemOom: boolean
) => {
    if (newZipCode.length === 5) {
        setCoreProductATPData([]);
        setATPCallMessage('');
        props.setStatusATPCall(false);
        props.setATPCall(false);
        _validateZipCode(
            props,
            newZipCode,
            setErrorZipCode,
            setItemOutOfMarket,
            setNewZipCode,
            setIsValidZipCode,
            false,
            setIsOOMZipCode,
            isItemOom
        );
        const cookies = new Cookies();
        setNewZipCode(newZipCode);
        setIsZipCodeChnaged(true);
        setIsItemOom(false);
        cookies.set(`zip_code`, newZipCode, { path: '/', expires: oneYearFromNow() });
        return true;
        // VSI customization - START - 24789
    } else if (newZipCode.length < 5) {
        setErrorZipCode('Please enter a valid zip code. ');
    }
    // VSI customization - END - 24789
    return false;
};

export const _deliveryMessage = (days: string) => {
    const date = new Date();
    const deliveryDate = date.setDate(date.getDate());
    let deliveryByMessage = '';
    deliveryByMessage = dayjs(deliveryDate).format('MMM D');
    let numberOfDays = parseInt(days, 10);
    let newDate = deliveryDate;
    let flag = true;
    while (numberOfDays > 0) {
        newDate = date.setDate(date.getDate() + 1);
        if (dayjs(newDate).format('d') !== '0' && dayjs(newDate).format('d') !== '6') {
            numberOfDays--;
        } else {
            flag = false;
        }
    }
    deliveryByMessage = flag && days === '1' ? `Tomorrow ${dayjs(Date.now()).format('MMM D')}` : dayjs(newDate).format('ddd MMM, D');
    return deliveryByMessage;
};

export const BuyboxDeliveryByMessage = (props: {
    buyboxProps: IBuyboxViewPropsExtended;
    itemOutOfMarket: boolean;
    setItemOutOfMarket: React.Dispatch<boolean>;
    SetoutOfStockSmallParcelState: React.Dispatch<boolean>;
    outOfStockSmallParcelState: boolean;
}): JSX.Element => {
    const { buyboxProps, itemOutOfMarket, setItemOutOfMarket, outOfStockSmallParcelState, SetoutOfStockSmallParcelState } = props;

    const {
        ATPDataFromBusiness,
        data: { productSpecificationData }
    } = buyboxProps;
    const prevZipCode = buyboxProps.state.batchedAtpInventoryStatusData?.zipCode;
    const cookies = new Cookies();
    const zipcode = cookies.get('zip_code');
    const productType = _getProductAttribute(buyboxProps);
    const [isZipCodeChnaged, setIsZipCodeChnaged] = React.useState(false);
    const [isValidZipCode, setIsValidZipCode] = React.useState(true);
    const [isOOMZipCode, setIsOOMZipCode] = React.useState(true);
    const [isItemOom, setIsItemOom] = React.useState(false);
    const [coreProductATPData, setCoreProductATPData] = React.useState(ATPDataFromBusiness);
    const [atpCallMessage, setATPCallMessage] = React.useState('');
    const [recordId, setRecordId] = React.useState(buyboxProps.data.product.result!.RecordId);
    const [itemId, setItemId] = React.useState(buyboxProps.data.product.result!.ItemId);
    const [isInput, setIsInput] = React.useState<boolean>(false);
    const [isAtpCallReturned, setIsAtpCallReturned] = React.useState<boolean>(false);
    const [newZipCode, setNewZipCode] = React.useState(zipcode !== undefined ? zipcode : '');
    const isCached = true;
    const {
        data: { storeSelectorState },
        state: { preferredStore }
    } = buyboxProps;
    let defaultError = '';

    if (storeSelectorState?.result?.prefferedStore?.Zip && storeSelectorState?.result?.prefferedStore?.Zip === newZipCode) {
        const getMessageValue = getBlockZipCodeMessage(
            storeSelectorState?.result?.prefferedStore?.State || '',
            buyboxProps.context.app.config.blockedStates
        );
        if (getMessageValue?.length > 0) {
            defaultError = getMessageValue[0].message;
        }
    }
    const [errorZipCode, setErrorZipCode] = React.useState(defaultError);

    // out of stock attribute value
    let outOfStock = productSpecificationData.result?.find(
        attr => attr.Name?.trim().toLowerCase() === buyboxProps.context.app.config.outOfStockProductKey?.trim().toLowerCase()
    )?.BooleanValue;

    //leadTime product attribute value
    let deliveryDays = productSpecificationData.result?.find(attr => attr.Name?.trim() === buyboxProps.context.app.config.leadTime)
        ?.TextValue;
    // eslint-disable-next-line prefer-const
    const { ecomAllVairantStockInfoConcatenated } = buyboxProps;
    if (ecomAllVairantStockInfoConcatenated && ecomAllVairantStockInfoConcatenated.length > 0) {
        for (let i = 0; i < buyboxProps.ecomAllVairantStockInfoConcatenated.length; i++) {
            const variantIdOOS = ecomAllVairantStockInfoConcatenated[i].split('|');
            if (variantIdOOS && variantIdOOS[0] === recordId.toString() && !!Number(variantIdOOS[1])) {
                outOfStock = true;
                break;
            }
        }
    }

    let deliveryByMessage = '';
    let deliveryByMessageRange = '';
    let coreProductATPCall = false;
    // eslint-disable-next-line prefer-const
    if (buyboxProps.data.product.result!.RecordId !== recordId || buyboxProps.data.product.result!.ItemId !== itemId) {
        setRecordId(buyboxProps.data.product.result!.RecordId);
        setItemId(buyboxProps.data.product.result!.ItemId);
    }
    React.useEffect(() => {
        // TODO: Handle Promise in a appropriate way
        if (productType === 'Core' && !outOfStock) {
            isAtpCallReturned && setIsAtpCallReturned(false);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            buyboxProps.data.product.result?.MasterProductId &&
                _coreProductATPCall(
                    buyboxProps,
                    setCoreProductATPData,
                    recordId,
                    itemId,
                    setATPCallMessage,
                    setIsAtpCallReturned,
                    isCached
                );
        }
    }, [itemOutOfMarket]);

    React.useEffect(() => {
        // TODO: Handle Promise in a appropriate way
        if (productType === 'Core' && !outOfStock) {
            isAtpCallReturned && setIsAtpCallReturned(false);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            buyboxProps.data.product.result?.MasterProductId &&
                _coreProductATPCall(
                    buyboxProps,
                    setCoreProductATPData,
                    recordId,
                    itemId,
                    setATPCallMessage,
                    setIsAtpCallReturned,
                    isCached
                );
        } else if (productType === 'Small Parcel') {
            void smallParcelATPInventoryStatusCall(
                buyboxProps,
                outOfStockSmallParcelState,
                SetoutOfStockSmallParcelState,
                recordId,
                itemId,
                newZipCode,
                prevZipCode
            );
        }
    }, [recordId]);

    React.useEffect(() => {
        // TODO: Handle Promise in a appropriate way
        if (productType === 'Core' && !outOfStock) {
            isAtpCallReturned && setIsAtpCallReturned(false);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            buyboxProps.data.product.result?.MasterProductId &&
                _coreProductATPCall(
                    buyboxProps,
                    setCoreProductATPData,
                    recordId,
                    itemId,
                    setATPCallMessage,
                    setIsAtpCallReturned,
                    isCached
                );
        } else if (productType === 'Small Parcel') {
            void smallParcelATPInventoryStatusCall(
                buyboxProps,
                outOfStockSmallParcelState,
                SetoutOfStockSmallParcelState,
                recordId,
                itemId,
                newZipCode,
                prevZipCode
            );
        }
    }, [preferredStore.OrgUnitNumber]);

    React.useEffect(() => {
        if (productType === 'Core' && zipcode?.length > 0 && !isOOMZipCode && !buyboxProps.ATPCall && !outOfStock) {
            isAtpCallReturned && setIsAtpCallReturned(false);
            buyboxProps.setATPCall(true);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            buyboxProps.data.product.result?.MasterProductId &&
                _coreProductATPCall(
                    buyboxProps,
                    setCoreProductATPData,
                    recordId,
                    itemId,
                    setATPCallMessage,
                    setIsAtpCallReturned,
                    isCached
                );
        }
        setIsOOMZipCode(true);
    }, [isOOMZipCode]);

    React.useEffect(() => {
        setNewZipCode(zipcode ? zipcode : '');
        setCoreProductATPData([]);
        setATPCallMessage('');
        buyboxProps.setStatusATPCall(false);
        buyboxProps.setATPCall(false);
        _validateZipCode(
            buyboxProps,
            newZipCode,
            setErrorZipCode,
            setItemOutOfMarket,
            setNewZipCode,
            setIsValidZipCode,
            false,
            setIsOOMZipCode,
            isItemOom
        );
        setIsItemOom(false);
        setIsZipCodeChnaged(true);
        buyboxProps.setZipCode(zipcode);
    }, [zipcode]);

    React.useEffect(() => {
        if (productType === 'Core') {
            setItemOutOfMarket(isItemOom);
        }
    }, [isItemOom]);
    const firstUpdate = React.useRef(true);
    let initial = false;
    React.useEffect(() => {
        if (firstUpdate?.current) {
            firstUpdate.current = false;
            initial = true;
        }
        buyboxProps.data.product.result?.MasterProductId &&
            newZipCode &&
            _validateZipCode(
                buyboxProps,
                newZipCode,
                setErrorZipCode,
                setItemOutOfMarket,
                setNewZipCode,
                setIsValidZipCode,
                initial,
                setIsOOMZipCode,
                isItemOom
            );
    }, [productType]);

    /**
     * isMFICore = Yes, isParcelable = No, shippingInformation = Core
     * if Above Condtions are true then this is a Core Item
     * call ATP proxy and make delivery by message
     */
    if (productType === 'Drop Ship') {
        if (outOfStockSmallParcelState !== false) {
            SetoutOfStockSmallParcelState(false);
        }
    }
    if (productType === 'Core' && !outOfStock) {
        const messageItemOutOfMarket = buyboxProps.context.app.config.messageForItemOutOfMarket
            ? buyboxProps.context.app.config.messageForItemOutOfMarket?.replace('{zipcode}', zipcode)
            : '';
        // Core Product
        coreProductATPCall = true;
        // outOfStock = false;
        if (outOfStockSmallParcelState !== false) {
            SetoutOfStockSmallParcelState(false);
        }
        if (isZipCodeChnaged) {
            setIsZipCodeChnaged(false);
        }
        deliveryByMessage = coreProductATPData ? _getSoonestDeliveryDate(coreProductATPData) : '';
        if (deliveryByMessage === '') {
            if (ATPDataFromBusiness !== null && ATPDataFromBusiness !== undefined && !isAtpCallReturned) {
                deliveryByMessage = _getSoonestDeliveryDate(ATPDataFromBusiness);
                if (deliveryByMessage === undefined || deliveryByMessage === null || deliveryByMessage === '') {
                    deliveryByMessage = `${buyboxProps.context.app.config.defaultDeliveryMessage} `;
                }
            }
        }
        // deliveryByMessage = deliveryMessage;
        const parsedMessage: IMfrmAtpMessage = atpCallMessage ? JSON.parse(`${atpCallMessage}`) : '';
        const noZipCodeGroup = buyboxProps.context.app.config.responseMessageForItemOutOfMarketZip?.replace('{zipcode}', zipcode);
        const outOfZone = buyboxProps.context.app.config.responseMessageForItemOutOfMarketOOZ;
        if (
            coreProductATPData?.length === 0 &&
            parsedMessage?.Message &&
            noZipCodeGroup &&
            outOfZone &&
            (parsedMessage?.Message?.toLowerCase() === outOfZone?.toLowerCase() ||
                parsedMessage?.Message?.toLowerCase() === noZipCodeGroup?.toLowerCase()) &&
            !itemOutOfMarket &&
            !isItemOom
        ) {
            setIsItemOom(true);
            setErrorZipCode(messageItemOutOfMarket);
        }

        if ((coreProductATPData?.length === 0 || deliveryByMessage === '') && isAtpCallReturned) {
            deliveryByMessage = itemOutOfMarket
                ? `Delivery `
                : buyboxProps.context.app.config.defaultDeliveryMessage
                ? `${buyboxProps.context.app.config.defaultDeliveryMessage?.trim()} `
                : '';
        }
    }
    /**
     * Check if no delivery days are found in product attribute then get it from site builder
     */
    if (
        (deliveryDays === '' || deliveryDays === undefined || deliveryDays === null) &&
        buyboxProps.context.app.config.brandList &&
        buyboxProps.context.app.config.brandList?.length > 0 &&
        !coreProductATPCall &&
        !outOfStockSmallParcelState
    ) {
        const brand =
            buyboxProps.context.app.config.brandBackofficeAttributePdp &&
            productSpecificationData.result
                ?.find(attr => attr.Name?.trim() === buyboxProps.context.app.config.brandBackofficeAttributePdp)
                ?.TextValue?.toLowerCase();
        if (brand) {
            buyboxProps.context.app.config.brandList?.map((brandList: IBrandListData) => {
                if (brandList?.brandName?.toLowerCase() === brand) {
                    deliveryDays =
                        brandList.brandLeadtime !== undefined && brandList.brandLeadtime !== '' && brandList.brandLeadtime !== null
                            ? brandList.brandLeadtime
                            : '';
                }
            });
        }
    }

    React.useEffect(() => {
        if (productType === 'Core' && ATPDataFromBusiness !== null && ATPDataFromBusiness !== undefined && !outOfStock) {
            deliveryByMessage = ATPDataFromBusiness ? _getSoonestDeliveryDate(ATPDataFromBusiness) : '';
            if (deliveryByMessage === undefined || deliveryByMessage === '') {
                deliveryByMessage = buyboxProps.context.app.config.defaultDeliveryMessage;
            }
            setCoreProductATPData(ATPDataFromBusiness);
        }
    }, [ATPDataFromBusiness]);

    /**
     * For Core item delivery message is empty and delivery days are found at any case then do following to get delivery by message
     */
    if (deliveryByMessage === '' && deliveryDays && deliveryDays !== '' && deliveryDays !== undefined) {
        const daysSpan = deliveryDays?.split('-');
        if (daysSpan && daysSpan[1] !== undefined && daysSpan.length) {
            daysSpan?.map((item: string, index: number) => {
                const date = new Date();
                const deliveryDate = date.setDate(date.getDate());
                if (parseInt(item, 10) > 0) {
                    let numberOfDays = parseInt(item, 10);
                    let newDate = deliveryDate;
                    while (numberOfDays > 0) {
                        newDate = date.setDate(date.getDate() + 1);
                        if (dayjs(newDate).format('d') !== '0' && dayjs(newDate).format('d') !== '6') {
                            numberOfDays--;
                        }
                    }
                    deliveryByMessage = dayjs(newDate).format('MMM D');
                    if (deliveryByMessageRange !== '') {
                        deliveryByMessageRange = `${deliveryByMessageRange} to ${deliveryByMessage}`;
                    } else {
                        deliveryByMessageRange = deliveryByMessage;
                        newDate = date.setDate(date.getDate() - parseInt(item[0], 10));
                    }
                }
            });
            deliveryByMessage = deliveryByMessageRange;
        } else {
            deliveryByMessage = _deliveryMessage(deliveryDays);
        }
    }

    if (deliveryByMessage === '' || outOfStock) {
        return <></>;
    }
    return (
        <Node className={isInput ? 'ms-buybox__delivery-message ms-buybox__delivery-message--input-active' : 'ms-buybox__delivery-message'}>
            {isInput ? (
                <>
                    {/* // VSI customization - START - 24789 */}
                    <Node className='ms-buybox__delivery-message-input field-group'>
                        <input
                            type='text'
                            className={`field-control ${newZipCode && 'field-control--value'} ${errorZipCode && 'field-control--error'}`}
                            value={newZipCode?.replace(/[^0-9]/g, '')}
                            maxLength={5}
                            autoFocus
                            onChange={event => {
                                setNewZipCode(event.target.value);
                                setErrorZipCode('');
                            }}
                            onKeyUp={e => {
                                if (
                                    e.which === 13 &&
                                    _updateZipCode(
                                        newZipCode,
                                        setNewZipCode,
                                        buyboxProps,
                                        setErrorZipCode,
                                        setItemOutOfMarket,
                                        setIsZipCodeChnaged,
                                        setIsValidZipCode,
                                        setCoreProductATPData,
                                        setATPCallMessage,
                                        setIsOOMZipCode,
                                        setIsItemOom,
                                        isItemOom
                                    )
                                ) {
                                    setIsInput(prevState => !prevState);
                                }
                            }}
                        />
                        <Node className='field-label' tag='label'>
                            Zip Code
                        </Node>
                        <Node
                            className='ms-buybox__delivery-message-button'
                            tag='button'
                            role='button'
                            onClick={() => {
                                if (
                                    _updateZipCode(
                                        newZipCode,
                                        setNewZipCode,
                                        buyboxProps,
                                        setErrorZipCode,
                                        setItemOutOfMarket,
                                        setIsZipCodeChnaged,
                                        setIsValidZipCode,
                                        setCoreProductATPData,
                                        setATPCallMessage,
                                        setIsOOMZipCode,
                                        setIsItemOom,
                                        isItemOom
                                    )
                                ) {
                                    setIsInput(prevState => !prevState);
                                }
                            }}
                        >
                            Update
                        </Node>
                    </Node>
                    {errorZipCode !== '' ? (
                        <Node className='ms-buybox__delivery-message-text-error'>{buyboxProps.resources.mfrmInvalidZipCode}</Node>
                    ) : (
                        <></>
                    )}
                    {/* // VSI customization - END - 24789 */}
                </>
            ) : (
                <>
                    {
                        <Node className={`ms-buybox__delivery-message-text-redesign  ${errorZipCode ? '' : 'truck'}`} tag='span'>
                            <Node className='ms-buybox__delivery-message-text-left' tag='span'>
                                {initial ? (
                                    newZipCode && isValidZipCode
                                ) : newZipCode ? (
                                    <>
                                        {errorZipCode ? (
                                            'Delivery '
                                        ) : (
                                            <>
                                                {productType === 'Core' ? '' : buyboxProps.resources.deliveryBy} {deliveryByMessage}
                                            </>
                                        )}{' '}
                                        to
                                    </>
                                ) : (
                                    'To Check Availability'
                                )}
                            </Node>
                            <Node
                                className='ms-buybox__delivery-message-link-redesign'
                                tag='button'
                                role='button'
                                tabIndex='0'
                                aria-pressed='false'
                                onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                                    setIsInput(prevState => !prevState);
                                    setNewZipCode(newZipCode);
                                    event.preventDefault();
                                    // @ts-ignore
                                    if ('utag' in window) {
                                        event.preventDefault();
                                        // @ts-ignore
                                        // tslint:disable-next-line: object-literal-key-quotes
                                        utag.link({
                                            event: 'PDP-card-action',
                                            event_category: 'PDP Card Action',
                                            event_action: 'Change Zip-Code Click',
                                            enhanced_action: 'change_zipcode',
                                            event_label: 'Change Zip-Code PDP',
                                            event_noninteraction: 'false'
                                        });
                                    }
                                }}
                            >
                                {initial ? newZipCode && isValidZipCode : newZipCode ? newZipCode : buyboxProps.resources.enterZipCode}
                            </Node>
                        </Node>
                    }
                    {errorZipCode !== '' ? (
                        <div className='ms-buybox__delivery-message-text-error' dangerouslySetInnerHTML={{ __html: errorZipCode }} />
                    ) : (
                        <></>
                    )}
                </>
            )}
        </Node>
    );
};
